module.exports = __webpack_public_path__ + "img/event.811ad351.jpeg";